module.exports = __webpack_public_path__ + "img/medal.b97da52a.svg";